var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSecuritySystem(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 23.724,
    height: 26.523,
    viewBox: "0 0 23.724 26.523",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #7d7d7d;\n      }\n\n      .cls-2, .cls-4, .cls-5 {\n        fill: none;\n        stroke-linecap: round;\n      }\n\n      .cls-2 {\n        stroke: #7d7d7d;\n        stroke-width: 1.5px;\n      }\n\n      .cls-2, .cls-4 {\n        stroke-linejoin: round;\n      }\n\n      .cls-3 {\n        fill: #fff;\n      }\n\n      .cls-4, .cls-5 {\n        stroke: #fff;\n        stroke-width: 0.5px;\n      }\n\n      .cls-4 {\n        stroke-miterlimit: 10;\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_11298",
    "data-name": "Group 11298",
    transform: "translate(-724.25 -4021.25)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_11297",
    "data-name": "Group 11297",
    transform: "translate(725 4022)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_11296",
    "data-name": "Group 11296"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_8060",
    "data-name": "Path 8060",
    className: "cls-1",
    d: "M24.428,963.617l8.334,3.687c-.071,5.091-1.2,8.326-2.781,10.57a17.332,17.332,0,0,1-5.554,4.716,17.356,17.356,0,0,1-5.561-4.716c-1.585-2.244-2.7-5.479-2.773-10.57l8.334-3.687Z",
    transform: "translate(-13.316 -960.646)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8061",
    "data-name": "Path 8061",
    className: "cls-2",
    d: "M21.095,957.367a.838.838,0,0,0-.321.069l-10.279,4.54a.854.854,0,0,0-.495.764c0,6.333,1.4,10.5,3.473,13.43a22.153,22.153,0,0,0,7.206,6.077.852.852,0,0,0,.868,0,22.156,22.156,0,0,0,7.206-6.077c2.074-2.934,3.473-7.1,3.473-13.43a.855.855,0,0,0-.495-.764l-10.279-4.54A.867.867,0,0,0,21.095,957.367Z",
    transform: "translate(-10 -957.367)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_11262",
    "data-name": "Group 11262",
    transform: "translate(7.793 8.509)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_1835",
    "data-name": "Ellipse 1835",
    className: "cls-3",
    cx: 0.626,
    cy: 0.626,
    r: 0.626,
    transform: "translate(2.591 6.695)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7177",
    "data-name": "Path 7177",
    className: "cls-4",
    d: "M2.775,37.5H1.144A.416.416,0,0,1,.7,37.122V33.776a.409.409,0,0,1,.444-.376H6.631a.409.409,0,0,1,.444.376v3.346a.409.409,0,0,1-.444.376H5.037",
    transform: "translate(-0.7 -30.141)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_10183",
    "data-name": "Group 10183",
    transform: "translate(0.864 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_7178",
    "data-name": "Path 7178",
    className: "cls-4",
    d: "M8.7,2.581A2.147,2.147,0,0,1,11.022.7c1.032,0,2.313.442,2.322,1.881",
    transform: "translate(-8.7 -0.7)"
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_1115",
    "data-name": "Line 1115",
    className: "cls-4",
    y2: 1.306,
    transform: "translate(0 1.881)"
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_1116",
    "data-name": "Line 1116",
    className: "cls-4",
    y2: 1.306,
    transform: "translate(4.636 1.881)"
  })), /*#__PURE__*/React.createElement("line", {
    id: "Line_1117",
    "data-name": "Line 1117",
    className: "cls-5",
    y2: 0.911,
    transform: "translate(3.224 5.328)"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSecuritySystem);
export default __webpack_public_path__ + "static/media/securitySystem.29dc9b487c58e19589c43cc35ae448a9.svg";
export { ForwardRef as ReactComponent };